// CSRFトークンを付けるためのヘルパ。
//
// マイページのAPIはセッションCookieで認証するため、Django の CSRF 保護が要る
// （Cookieはブラウザが自動送信するので、トークンが無いと第三者サイトからのPOSTを
//  サーバ側で区別できない）。BE側は @csrf_exempt を外してあり、POST には
// X-CSRFToken が必須。付け忘れると 403 になる。
//
// トークンの入手経路: /api/employee/me/ が @ensure_csrf_cookie で csrftoken クッキーを
// 配る。このGETは共通シェル(MypageLayout)が全ページで叩くので、画面を開いた時点で
// 必ずクッキーがある。
//
// 注) Cookie を使わない経路（LIFF打刻＝idToken認証、LINE Webhook＝署名検証）は
//     BE側で @csrf_exempt のままなので、ここを通す必要はない。

// document.cookie から csrftoken を取り出す（Django既定のクッキー名）。
export function csrfToken() {
  const m = document.cookie.match(/(?:^|;\s*)csrftoken=([^;]*)/);
  return m ? decodeURIComponent(m[1]) : "";
}

// JSON POST 用のヘッダ。既存の { "Content-Type": "application/json" } の置き換え。
export function jsonHeaders() {
  return { "Content-Type": "application/json", "X-CSRFToken": csrfToken() };
}

// FormData POST 用のヘッダ。Content-Type はブラウザに境界文字を付けさせるため指定しない。
export function formHeaders() {
  return { "X-CSRFToken": csrfToken() };
}
